import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FileText, Mail, Send, Settings, ArrowLeft, BookOpen, Building2, Rss, Sparkles } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

const NAV = [
  { to: '/student/cvs',           icon: FileText,  label: 'CVs'           },
  { to: '/student/coverletters',  icon: BookOpen,  label: 'Cover Letters' },
  { to: '/student/emailbodies',   icon: Mail,      label: 'Email Bodies'  },
  { to: '/student/companies',     icon: Building2, label: 'Companies'     },
  { to: '/student/find-jobs',     icon: Rss,       label: 'Find Jobs'     },
  { to: '/student/ai-application',icon: Sparkles,  label: 'AI Application'},
  { to: '/student/apply',         icon: Send,      label: 'Apply for Job' },
  { to: '/student/settings',      icon: Settings,  label: 'Settings'      },
];

export function StudentSidebar(): React.ReactElement {
  const { user } = useAuth();
  const navigate = useNavigate();
  const initials = user?.displayName ? user.displayName.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() : (user?.email?.[0] || '?').toUpperCase();

  return (
    <aside style={{
      width: 'var(--sidebar-w)', position: 'fixed', top: 0, left: 0, bottom: 0,
      background: 'var(--surface)', borderRight: '1px solid var(--border)',
      display: 'flex', flexDirection: 'column', zIndex: 40,
    }}>
      {/* Logo */}
      <div style={{ padding: '22px 20px 16px', borderBottom: '1px solid var(--border)' }}>
        <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 17, color: 'var(--accent)', marginBottom: 2 }}>LeadFlow</div>
        <div style={{ fontSize: 11, color: 'var(--text3)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Student Mode</div>
      </div>

      {/* Back to LeadFlow */}
      <div style={{ padding: '12px 14px', borderBottom: '1px solid var(--border)' }}>
        <button onClick={() => navigate('/app/dashboard')} style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 9, padding: '8px 10px', borderRadius: 8, background: 'rgba(108,99,255,0.06)', border: '1px solid rgba(108,99,255,0.15)', color: 'var(--accent)', cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'DM Sans', transition: 'all 0.15s' }}>
          <ArrowLeft size={13} /> Switch to LeadFlow
        </button>
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 4 }}>
        {NAV.map(({ to, icon: Icon, label }) => (
          <NavLink key={to} to={to} style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px', borderRadius: 9,
            textDecoration: 'none', fontSize: 13, fontWeight: isActive ? 600 : 400,
            color: isActive ? 'var(--accent)' : 'var(--text2)',
            background: isActive ? 'rgba(108,99,255,0.1)' : 'transparent',
            transition: 'all 0.15s',
          })}>
            <Icon size={16} />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* User info */}
      <div style={{ padding: '14px 16px', borderTop: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ width: 32, height: 32, borderRadius: 9, background: 'rgba(108,99,255,0.12)', color: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Syne', fontWeight: 700, fontSize: 13, flexShrink: 0 }}>{initials}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 12, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.displayName || 'Student'}</div>
          <div style={{ fontSize: 11, color: 'var(--text3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.email}</div>
        </div>
      </div>
    </aside>
  );
}
